import { isNotNullOrUndefined } from 'common/data-util';
import React from 'react';

interface ChargingStationProps {
  serialNumber: string;
  model: string;
  nozzleCount?: number
}

export function ChargingStation({ serialNumber, model, nozzleCount }: ChargingStationProps) {
  return (
    <div
      className="row bg-light rounded px-2 py-3 px-lg-3 mx-0 my-2"
    >
      <div className="col-12 col-lg d-flex flex-row mb-2 mb-lg-0">
        <strong>{serialNumber}</strong>
      </div>
      <div className="col-12 col-lg d-flex flex-row">
        <strong className="text-left">{model}</strong>
      </div>
      {
        isNotNullOrUndefined(nozzleCount) ? (
          <div className="col-12 col-lg d-flex flex-row">
            <strong className="text-left">{nozzleCount} tk</strong>
          </div>
        ) : null
      }
    </div>
  );
}